<p-toolbar>
  <div class="p-toolbar-group-left">
    <p-breadcrumb [model]="items" class="p-d-none p-d-lg-inline"></p-breadcrumb>
    <p-dropdown [options]="payPeriods" 
                class="p-inputtext-sm p-mr-2 p-d-none p-d-lg-inline" 
                [style]="{'width': '200px', 'background':'rgba(255,255,255,0.5)'}"
                appendTo="body"
                showClear="true"
                inputid="payPeriod" 
                optionLabel="title"
                dataKey="id"
                placeholder="Select Date Range"
                [(ngModel)]="selectedDateRange"
                (onChange)="onDateRangeChanged($event)"></p-dropdown>

    <p-calendar class="p-inputtext-sm p-mr-2" 
                appendTo="body"
                showIcon="true" 
                dateFormat="dd/mm/yy"
                [style]="{'width': '140px', 'background':'rgba(255,255,255,0.5)'}"
                [monthNavigator]="true"
                [yearNavigator]="true"
                yearRange="{{yearRange}}"
                [(ngModel)]="selectedDateRange.range.from"></p-calendar>

    <p-calendar class="p-inputtext-sm p-mr-2" 
                appendTo="body"
                showIcon="true" 
                dateFormat="dd/mm/yy"
                [style]="{'width': '140px', 'background':'rgba(255,255,255,0.5)'}"
                [monthNavigator]="true"
                [yearNavigator]="true"
                yearRange="{{yearRange}}"
                [(ngModel)]="selectedDateRange.range.to"></p-calendar>

    <!-- Display only on bigger than md screens-->
    <span class="p-d-none p-d-md-inline">
      <button pButton pRipple 
              label="Load Timesheet" 
              class="p-button-sm p-button-raised" 
              icon="fas fa-sync-alt fa-1x" 
              type="button" 
              (click)="loadPayrollTimesheet()"></button>

      <button pButton pRipple 
              label="Excel Export" 
              class="p-button-sm p-button-raised" 
              icon="fas fa-download fa-lg" 
              type="button" 
              (click)="exportPayrollTimesheet()"></button>
    </span>

    <!-- Display only on smaller than md screens-->
    <span class="p-d-md-none">
      <button pButton pRipple 
              class="p-button-rounded p-button-success" 
              icon="pi pi-refresh" 
              type="button" 
              (click)="loadPayrollTimesheet()"></button>

      <button pButton pRipple 
              *ngIf="canExportTimeSheet()"
              class="p-button-rounded p-button-success" 
              icon="pi pi-refresh" 
              type="button" 
              (click)="exportPayrollTimesheet()"></button>

    </span>
  </div>

  <div class="p-toolbar-group-right">
    <i class="pi-fw far fa-bell p-mr-4 p-mt-2 p-text-secondary toolbar-badge-icon text-danger" pBadge 
        *ngIf="getNumberOfErrorLines() > 0"
        style="cursor:pointer"
        severity="danger"
        pTooltip="Lines with possible error: {{getNumberOfErrorLines()}}. Click to show error data."
        tooltipPosition="left"
        (click)="loadPayrollTimesheet(true)"
        value="{{getNumberOfErrorLines()}}"></i>
    <i class="pi-fw far fa-bell p-mr-4 p-mt-2 p-text-secondary toolbar-badge-icon" pBadge 
        style="cursor:pointer"    
        severity="info"
        pTooltip="Total lines: {{totalLines}}. Click to show all data."
        tooltipPosition="left"
        (click)="loadPayrollTimesheet()"
        value="{{totalLines}}"></i>
  </div>
</p-toolbar>

<div class="m-1" style="height:calc(100% - 36px)">
   <ngx-spinner bdColor="rgba(128, 128, 128, 0.8)"
                size="default"
                color="#2f9cf2"
                type="line-scale-pulse-out"
                [name]="spinnerName"
                [fullScreen]="false">
     <p style="color:white" >Generating payroll timesheet... </p>
   </ngx-spinner>

  <ag-grid-angular
    style="width: 100%; height: 100%;"
    class="ag-theme-alpine"
    [rowData]="payrollTimesheets"
    [columnDefs]="gridHeaders"
    [gridOptions]="gridOptions"
    rowSelection="single"
    (gridReady)="onGridReady($event)">
  </ag-grid-angular>
</div>

